export const SET_PRESENCE_THRESHOLD_DATA = 'setPresenceThresholdData';
export const SET_CONTEXT_THRESHOLD_DATA = 'setContextThresholdData';
export const CLEAR_FIND_SIMILAR_REDUX_STORE = 'clearFindSimilarReduxStore';
